<template>
<m-setup-wrapper :can-start-game="lobby.players.length > 1" @startGame="startGame">

  <h1>Play online</h1>

  <div v-if="!lobby.isInLobby" class="mb4">
    <b-field label="Room name">
      <b-input v-model="roomName"></b-input>
    </b-field>
    <b-button type="is-primary" @click="joinRoom" :loading="$wait.is('joining')">Join</b-button>
  </div>

  <div v-if="lobby.isInLobby">
    <b-field label="link to join">
      <b-input readonly v-model="linkToJoin"></b-input>
    </b-field>

    <m-game-settings v-model="gameSettings" :enabled-settings="'all'"></m-game-settings>
    <player-list :permissions="{ canAdd: false, canRemovePlayers: false }" v-model="lobbyPlayers"></player-list>

  </div>
</m-setup-wrapper>
</template>

<script>
import Ws from '@adonisjs/websocket-client';
import SetupBase from '@/components/setup/SetupBase.vue';

export default {
  extends: SetupBase,
  data() {
    return {
      roomName: null
    };
  },
  methods: {
    async joinRoom() {
      this.$wait.start('joining')
      const channel = this.$store.state.websocket.subscribe(
        `lobby:${this.$utils.slugify(this.roomName)}`,
      );
      await this.$store.dispatch('setupOnlineLobby', {
        channel,
      });
      this.$set(this, 'gameSettings', this.$store.state.lobby.gameSettings)
      this.$wait.end('joining')
    },

    startGame() {
      const cards = this.utils.generateLayout(this.gameSettings);
      this.$store.state.lobby.channel.emit('game:startRequest', {
        gameSettings: this.gameSettings,
        cards,
      });
    },
  },

  async created() {

    if (!this.$store.state.websocket) {
      const websocket = Ws(process.env.VUE_APP_WS_URL);
      this.$store.commit('setWebsocket', websocket);

      websocket.on('open', () => {
        // console.log('connected to websocket');
      });

      websocket.connect();
    }

    if (this.$route.query.room) {
      this.roomName = this.$route.query.room;
      this.joinRoom();
    }
  },

  computed: {
    lobby() {
      return this.$store.state.lobby;
    },

    linkToJoin() {
      return this.roomName && `${process.env.VUE_APP_URL}setup/online?room=${this.$utils.slugify(
        this.roomName,
      )}`;
    },
  },

  mounted() {
    if (this.$refs.roomInput) {
      this.$refs.roomInput.$el.focus();
    }
  },

  beforeDestroy() {
    // if (this.$store.state.websocket) {
    //   this.$store.state.websocket.close();
    // }
    // this.$store.dispatch("leaveGame");
  }
};
</script>

<style lang="scss" scoped>
</style>
